import gql from 'graphql-tag';

import { getSingleProp, prepareACDebugContext } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { FRAGMENT_DETECTED_BRAND_TERM } from './schema';

const MUTATION = gql`
  mutation DetectBrandTerms($workspaceId: ID!, $texts: [String!]!) {
    detectBrandTerms(workspaceId: $workspaceId, texts: $texts) {
      ...DetectedBrandTerm
    }
  }
  ${FRAGMENT_DETECTED_BRAND_TERM}
`;

export const detectBrandTerms = async ({ workspaceId, text }, options) => {
  const variables = { workspaceId, texts: [text] };
  const mutateOptions = {
    mutation: MUTATION,
    variables,
    context: prepareACDebugContext('DetectBrandTerms', variables),
  };

  if (options && options.abortSignal) {
    mutateOptions.context = {
      ...mutateOptions.context,
      fetchOptions: {
        signal: options.abortSignal,
      },
    };
  }

  const result = await apolloClient.mutate(mutateOptions);
  return getSingleProp(result.data)?.[0];
};
